import { ApiRetailerPaymentType } from '@vend/types'
import { useCallback } from 'react'
import { IntegratedPaymentOption } from '../PaymentModal/types'

export const useHandleIntegrationPayment = (amountTendered: string) => {
  const handleIntegrationPayment = useCallback(
    (paymentType: ApiRetailerPaymentType): IntegratedPaymentOption => {
      return {} as IntegratedPaymentOption // FIXME: Handle integration payment
    },
    []
  )
  return {
    handleIntegrationPayment,
  }
}
